import { render, staticRenderFns } from "./PivotComponent.vue?vue&type=template&id=e468d622&scoped=true&"
import script from "./PivotComponent.vue?vue&type=script&lang=js&"
export * from "./PivotComponent.vue?vue&type=script&lang=js&"
import style0 from "./PivotComponent.vue?vue&type=style&index=0&id=e468d622&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e468d622",
  null
  
)

export default component.exports